import React from 'react';
import ReactDOM from 'react-dom/client';
import CacheBuster from 'react-cache-buster';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';
import { AppContextProvider } from './provider';
import version from '../package.json';
import { Loading } from './components';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <AppContextProvider>
                <CacheBuster
                    currentVersion={version}
                    isEnabled={true} //If false, the library is disabled.
                    isVerboseMode={false} //If true, the library writes verbose logs to console.
                    loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
                    metaFileDirectory={'./'} //If public assets are hosted somewhere other than root on your server.
                >
                    <App />
                </CacheBuster>
            </AppContextProvider>
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
